// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-container[data-v-51fe506c]{width:100%;display:flex;flex-direction:row;color:var(--pult-text);align-items:center}.badge-container .badge-title[data-v-51fe506c]{align-self:baseline;width:100%;max-width:193px;min-width:193px;padding:1px}.badge-container .badge-title .badge[data-v-51fe506c]{width:100%;line-height:22px;background:var(--pult-bg);padding:6px 16px}.badge-container .badge-body[data-v-51fe506c]{line-height:22px;display:flex;padding:8px 16px}", ""]);
// Exports
module.exports = exports;
